import { render, staticRenderFns } from "./PedimentosList.vue?vue&type=template&id=aa8ba602&scoped=true"
import script from "./PedimentosList.vue?vue&type=script&lang=js"
export * from "./PedimentosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8ba602",
  null
  
)

export default component.exports